import { useState } from 'react';
import styled from '@emotion/styled';
import { HELP_URL, POLICY_URL, PRIVACY_URL, YOUTH_URL } from '@diritto/common/constants/url';
import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { ArrowIcon } from 'icons/ArrowIcon';
import { ContentBodyPaddingContainer } from 'ui-components/layout/containers/ContentBodyCenterContainer';
import { ExternalLink } from 'ui-components/common/ExternalLink';
import { Link } from 'ui-components/common/Link';

interface FooterProps {
  className?: string;
}

export const Footer = ({ className }: FooterProps) => {
  const [toggle, setToggle] = useState(false);

  return (
    <StyledFooter className={className}>
      <ContentBodyPaddingContainer>
        <StyledItemsWrapper>
          <StyledItem>
            <Link href={HELP_URL}>고객센터</Link>
          </StyledItem>
          <StyledItem>
            <ExternalLink href={POLICY_URL}>이용약관</ExternalLink>
          </StyledItem>
          <StyledItem>
            <ExternalLink href={PRIVACY_URL}>
              <b>개인정보처리방침</b>
            </ExternalLink>
          </StyledItem>
          <StyledItem>
            <ExternalLink href={YOUTH_URL}>청소년 보호 정책</ExternalLink>
          </StyledItem>
        </StyledItemsWrapper>
        <StyledToggleWrapper>
          <StyledToggleItem onClick={() => setToggle(prev => !prev)}>
            <StyledText>리디(주) 사업자 정보</StyledText>
            <StyledIcon color={Color.Gray500} className="size-[16px]" direction={toggle ? 'up' : 'down'} />
          </StyledToggleItem>
          {toggle && (
            <StyledHideItem>
              <CompanyInfo />
            </StyledHideItem>
          )}
        </StyledToggleWrapper>
      </ContentBodyPaddingContainer>
    </StyledFooter>
  );
};

const CompanyInfo = () => (
  <StyledInfo>
    대표자: 배기식
    <br />
    <StyledBuzInfoWrapper>
      <div>사업자 등록번호: 120-87-27435</div>
      <ExternalLink href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1208727435" rel="noopener noreferrer">
        <StyledBuzInfoButton>
          사업자 정보 확인
          <ArrowIcon direction="right" className="size-[12px]" color={Color.Primary400} />
        </StyledBuzInfoButton>
      </ExternalLink>
    </StyledBuzInfoWrapper>
    통신판매업 신고번호: 제 2009-서울강남 35-02139호
    <br />
    대표전화: 1644-0331
    <br />
    이메일: help@ridi.com
    <br />
    주소: 서울시 강남구 역삼동 702-28
    <br />
    어반벤치빌딩 10층(테헤란로 325)
  </StyledInfo>
);

const StyledInfo = styled.div`
  text-align: center;
  color: ${Color.Gray600};
  ${Typography.XXXSmall};
  font-weight: ${FontWeight.Medium};
`;

const StyledBuzInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const StyledBuzInfoButton = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  color: ${Color.Primary400};
  ${Typography.XXXSmall};
  margin-left: 10px;
`;

const StyledFooter = styled.footer`
  display: block;
  width: 100%;
  margin-top: 32px;
  margin-bottom: 16px;
`;

const StyledItemsWrapper = styled.ul`
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: center;
`;

const StyledItem = styled.li`
  display: block;
  margin: 5px 10px;
  color: ${Color.Gray600};
  cursor: pointer;
  ${Typography.XXSmall};

  &:first-of-type {
    margin-left: 0;
  }
`;

const StyledToggleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledToggleItem = styled.div`
  display: flex;
  align-items: center;
`;

const StyledText = styled.p`
  color: ${Color.Gray600};
  ${Typography.XXXSmall};
`;

const StyledIcon = styled(ArrowIcon)`
  margin-left: 5px;
  color: ${Color.Gray400};
`;

const StyledHideItem = styled.div`
  padding: 20px 0;
`;
